import { render, staticRenderFns } from "./FbLayout.vue?vue&type=template&id=06bdc8e2&scoped=true"
import script from "./FbLayout.vue?vue&type=script&lang=js"
export * from "./FbLayout.vue?vue&type=script&lang=js"
import style0 from "./FbLayout.vue?vue&type=style&index=0&id=06bdc8e2&prod&lang=scss&scoped=true"
import style1 from "./FbLayout.vue?vue&type=style&index=1&id=06bdc8e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdc8e2",
  null
  
)

export default component.exports